"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LOGGED_OUT_HOME_PATH } from "@/lib/landingTest";
import { isPublicNavActive, publicNavItems, PublicNavDropdown } from "@/components/publicNav";

export const Footer = () => {
  const pathname = usePathname();

  const NAV_LINKS = publicNavItems(LOGGED_OUT_HOME_PATH);

  const SOCIAL_LINKS = [
    { href: "https://www.facebook.com/culineer", src: "/images/facebook.svg", alt: "Facebook" },
    { href: "https://www.instagram.com/culineerapp/?hl=en", src: "/images/insta.svg", alt: "Instagram" },
    { href: "https://x.com/culineer", src: "/images/twitter.svg", alt: "Twitter" },
  ];

  const isActive = (path: string) => isPublicNavActive(pathname, path); 

  return (
    <footer className="bg-white py-6 shadow-md">
      <div className="container mx-auto flex max-w-[1536px] flex-col gap-6 px-4 md:px-8 lg:px-16">
      <div className="flex flex-col items-start justify-between gap-6 py-4 md:flex-row md:items-center">
        <Link href="/" className="flex items-center self-start">
          <Image
            src="/images/logo.svg"
            alt="Culinear"
            className="w-36"
            width={144}
            height={40}
          />
        </Link>

        <nav className="flex flex-wrap items-center justify-center gap-6 text-[14.38px] md:text-lg">
          {NAV_LINKS.map((item) =>
            item.items ? (
              <PublicNavDropdown
                key={item.label}
                label={item.label}
                items={item.items}
                pathname={pathname}
                openUp
              />
            ) : (
              <Link
                key={item.href}
                href={item.href || "/"}
                className={
                  isActive(item.href || "/") ? "text-[#85C349]" : "hover:text-[#85C349]"
                }
              >
                {item.label}
              </Link>
            )
          )}
        </nav>

        <div className="flex gap-2">
          {SOCIAL_LINKS.map(({ href, src, alt}) => (
            <Link
              key={alt}
              href={href}
              target="_blank"
              className="flex items-center gap-3 p-2 border rounded-full shadow-sm"
            >
              <Image src={src} alt={alt} width={20} height={20} />
            </Link>
          ))}
        </div>
      </div>

      <hr className="border-t" />

      <div className="flex flex-col items-center justify-between gap-4 text-[14.38px] md:flex-row md:text-lg">
        <span>© 2025 Culineer. All rights reserved.</span>
        <div className="flex gap-4">
          <Link href="/terms-of-service" className="hover:underline">
            Terms & Conditions
          </Link>
          <Link href="/privacy" className="hover:underline">
            Privacy Policy
          </Link>
        </div>
      </div>
      </div>
    </footer>
  );
};
